module.exports = "/images/namecontainer-right.png?d60b2c61c9b181f683b298160fb0b935";